var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',[_vm._v(_vm._s(_vm.eventName))]),_c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.participant.name))])],1),_c('v-card',[_c('v-card-title',[_vm._v("抽選状況")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }